'use client'

import { useSearchParams, usePathname, useRouter } from 'next/navigation'

interface UseReplaceParams {
  key: string
  value: string
}

export const useReplaceParams = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { replace } = useRouter()

  const replaceParams = (params: UseReplaceParams | UseReplaceParams[]) => {
    const urlParams = new URLSearchParams(searchParams!)

    if (Array.isArray(params)) {
      // Handle array of parameters
      params.forEach(({ key, value }) => {
        urlParams.set(key, value)
      })
    } else {
      // Handle single parameter object
      urlParams.set(params.key, params.value)
    }

    replace(`${pathname}?${urlParams.toString()}`)
  }

  return {
    replaceParams,
    searchParams,
  }
}
